<div *ngIf="successMessage" class="alert alert-success" role="alert">
    <mat-icon style="vertical-align: text-bottom;">thumb_up</mat-icon> &nbsp;
    <label style=" vertical-align: text-bottom; margin-bottom: 0rem;">
        {{successMessage}}
    </label>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <mat-icon style="vertical-align: text-bottom;">thumb_down</mat-icon> &nbsp;
    <label style=" vertical-align: text-bottom; margin-bottom: 0rem;">
        {{errorMessage}}
    </label>
</div>